<div oui-dialog-title>
  <div class="flex-horizontal flex-center width-fill-available">
    <h6>Copier le lien de dépôt</h6>
  </div>
  <div class="content-right width-100-pc">
    <oui-button
      color="secondary"
      type="icon">
      <oui-icon mat-dialog-close>close</oui-icon>
    </oui-button>
  </div>
</div>
<oui-dialog-content
  class="content flex-vertical gap-24"
  [scroll]="true">
  <div>Copiez ce lien et transmettez-le à l’investisseur pour qu’il accède à son espace de dépôt MyStellium.</div>
  <div>
    <oui-button
      type="outlined"
      iconPrefix="content_copy"
      #linkTt="ouiTooltip"
      (click)="copyToClipboard(data.magicLinkPath, linkTt)"
      (keydown.enter)="copyToClipboard(data.magicLinkPath, linkTt)"
      [ouiTooltip]="copyTooltip()"
      (mouseleave)="resetTooltip()">
      Copier le lien sécurisé
    </oui-button>
  </div>
  <oui-banner
    title="Ce lien est valable 30 jours. Il est réactivé pour 30 jours supplémentaires à chaque nouvelle demande ajoutée."
    [showCloseButton]="false">
  </oui-banner>
</oui-dialog-content>
